import restclient from "@/v1/services/restclient";
import restclientLaunch from "@/v1/services/restclientLaunch";

/**
 * getLaunchEmbedded
 * @param {string} type - The type of the request
 * @param {string} query - Query to be send in the request
 * @param {object} config - config of the request
 * @returns {Promise}
 */
export const getLaunchEmbedded = async (type, query, config) => {
  const response = await restclientLaunch.get(`${type}${query}`, config);
  return response.data;
};

/**
 * getGameLink
 * @param {string} target - UUID of the display url
 * @returns {Promise}
 */
export const getGameLink = async target => {
  const response = await restclient.get(`api/v1/encoded-launch-records/${target}`);
  return response.data;
};
